
import { mapState } from 'vuex';
import HorizontalScroll from './components/HorizontalScroll.vue';

export default {
  i18nComponentKey: 'WidgetReviewsHorizontalScroll.WidgetReviewsHorizontalScrollPc',
  name: 'WidgetReviewsHorizontalScrollPc',
  components: { HorizontalScroll },
  computed: {
    ...mapState('widget', ['widget'])
  }
};
